import { axios } from "apis";
import { User } from "models";

const ENDPOINT = 'Users';

export const UserService = {
	getAll: async (): Promise<User[]> => {
		const response = await axios.get<User[]>(`${ENDPOINT}`);
		return response.data;
	},
	getAllForUser: async (): Promise<User[]> => {
		const response = await axios.get(`${ENDPOINT}/GetAllForUser`);
		return response.data;
	},
	getById: async (id: number): Promise<User> => {
		const response = await axios.get(`${ENDPOINT}/${id}`);
		return response.data;
	},
	ban: async (id: number): Promise<any> => {
		await axios.post(`${ENDPOINT}/BanUser/${id}`);
	},
	resetPassword: async (email: string, token: string, password: string) => {
		const formData = new FormData();
		formData.append('token', token);
		formData.append('email', email);
		formData.append('password', password);
		await axios.post(`${ENDPOINT}/ResetPassword`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
	},
	requestPasswordReset: async (email: string) => {
		try {
			await axios.post(`${ENDPOINT}/RequestPasswordReset?email=${email}`);
		}
		catch (e: any) {
			throw new Error(e.response?.data ?? 'Unknown error. Please try again.');
		}
	},
	changeEmail: async (email: string, newEmail: string, token: string) => {
		try {
			await axios.post(`${ENDPOINT}/ChangeEmail?email=${email}&newEmail=${newEmail}&token=${token}`);
		}
		catch (e: any) {
			throw new Error(e.response?.data ?? 'Unknown error. Please try again.');
		}
	}
};